import React, { useState, useEffect } from "react";
import { injectIntl } from "react-intl";
import "./style.scss";
import CancelIcon from '@material-ui/icons/Cancel';
import { useDispatch, useSelector } from "react-redux";
import Autocomplete from '@material-ui/lab/Autocomplete';
import ConfirmDialog from "../../ConfirmDialog/ConfirmDialog";
import { getLabtestsListRequest } from "../../../store/appointments/actions";
import { createSendLabTestRequest } from "../../../store/labTests/actions";



const SuggessionForm = ({ intl: { messages }, show, close, patientId }) => {
     const lang = localStorage.getItem("lang") || "en";
     const dispatch = useDispatch();
     const { labtests } = useSelector((state) => state.appointments);
     const { labtestCreated } = useSelector((state) => state.labTests);
     const [feedBack, setFeedBack] = useState(null);
     const [showConfirmation, setShowConfirmation] = useState(false);
     const [selectedLabtest, setSelectedLabtest] = useState(null);
     const [inputValue, setInputValue] = useState(null);
     const [labsList, setLabsList] = useState([]);

    useEffect(() => {
        dispatch(getLabtestsListRequest());
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dispatch]);

    useEffect(() => {
        if (labtests) {
            setLabsList(labtests.map((lab) => {
                return {
                    id: lab.id,
                    name: lang === "ar" ? `${lab.name?.ar}-${lab.reference_lab.ar}` : `${lab.name?.en}-${lab.reference_lab.en}`,
                };
            }));
        }
    }, [labtests, lang]);

     const [formData, setFormData] = useState({
        id: null,
        patient_id: patientId,
        lab_test_id: 0,
        lab_test_name: "",
        notes: '',
     });
   
    const clear = () => {
        setFormData({
            id: null,
            patient_id: patientId,
            lab_test_id: 0,
            lab_test_name: "",
            notes: '',
        });
        setSelectedLabtest(null);
        setFeedBack(null);
    }

    useEffect(() => {
        if (patientId) {
            setFormData({ ...formData, patient_id: patientId });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [patientId]);

    //AutoComplete Selection change
    useEffect(() => {
        if (selectedLabtest) {
            setFormData({ ...formData, lab_test_id: selectedLabtest });
        } else {
            setFormData({ ...formData, lab_test_id: 0 });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedLabtest]);

     //Clear and close
     useEffect(() => {
        if (labtestCreated) {
            clear();
            close();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [labtestCreated]);

    const save = () => {
        if (!formData.patient_id) {
            setFeedBack('No Patient Selected');
            return;
        }
        if (formData.lab_test_id === 0) {
            setFeedBack(messages.appointments.app_test_required);
            return;
        }
        dispatch(createSendLabTestRequest(formData));
    }

    return (
        <div className={`test-modal_container ${show && " show"} ${lang === 'ar' && 'rtlPosition'}`}>
            <div className="test-modal_container_content">
                    <CancelIcon onClick={close} className="test-modal_container_content_close" />
                <div className="test-modal_container_content_header" style={{ marginBottom: '40px' }}>
                    <h4>{messages.appointments.add_test}</h4>
                </div>
                <div className="test-modal_container_content_body">
                    <form>
                        <label htmlFor="code" className='required'>{messages.appointments.select_test}</label>
                        <div className="labtest_auto_complete">
                            <Autocomplete
                                id="combo-box-demo"
                                value={selectedLabtest}
                                onChange={(event, newValue) => {
                                    setSelectedLabtest(newValue.id);
                                }}
                                inputValue={inputValue}
                                onInputChange={(event, newInputValue) => {
                                    setInputValue(newInputValue);
                                }}
                                options={labsList}
                                getOptionSelected={(option) => option.id === selectedLabtest}
                                getOptionLabel={(option) => option.name || inputValue}
                                style={{ width: '100%' }}
                                renderInput={(params) => (
                                    <div ref={params.InputProps.ref}>
                                      <input placeholder={messages.appointments.select_test} type="text" id="testlab" {...params.inputProps} />
                                    </div>
                                  )}
                            />
                        </div>

                        <label htmlFor="suggession">{messages.appointments.suggession_recommendation}</label>
                        <textarea
                            id='suggession'
                            name="suggession"
                            placeholder={messages.appointments.suggession_recommendation_placeholder}
                            value={formData.notes}
                            onChange={(e) => setFormData({ ...formData, notes: e.target.value })}
                            rows={3}
                            ></textarea>
                        <div className="actions">
                                <button className="cancel" 
                                    onClick={(e) => {
                                        e.preventDefault();
                                        close();
                                        }}>
                                        {messages.patients.form.btn_cancel}                           
                                </button>
                                <button onClick={(e) =>  {
                                    e.preventDefault();
                                    save();
                                    }} >
                                    {messages.patients.form.btn_save}
                                </button>
                        </div>
                        <p id="feedback"><span style={{ background: '#FFF' }}>{feedBack}</span></p>
                    </form>   
                </div>
            </div>
            <ConfirmDialog show={showConfirmation} 
                     onCancel={() => setShowConfirmation(false)}
                     onConfirm={() => {
                        setShowConfirmation(false);
                        clear();
                        close();
                     }}
                     content={messages.warningMsgs.warning_close_window}
                     cancelBtn={messages.warningMsgs.cancel}
                     confirmBtn={messages.warningMsgs.confirm} />
        </div>
    );
}
export default injectIntl(SuggessionForm);
